<template>
  <div class="main">
    <report-top>
      <ly-search
        slot="search"
        v-model="searchItem.keyword"
        @search="search"
      ></ly-search
    ></report-top>
    <selectTool ref="selectTool"
      ><template slot="btn"
        ><Button @click="getSearchItem" type="error" class="chaxun">查询</Button
        ><Button @click="openAdd" type="primary" class="chaxun"
          >新增</Button
        ></template
      ></selectTool
    >

    <Table
      border
      :columns="columns"
      :data="tableData"
      no-data-text="<div class='table-no-data'></div>"
      :height="utils.setTableHeight(200)"
      @on-expand="abcabc"
    >
      <template slot-scope="{ row, index }" slot="status2">
        <Tag color='blue' @click="openStatus(row)">{{ row.status2 }}</Tag>
      </template>
      <template slot-scope="{ row, index }" slot="baifang">
        <Button @click="openStatus(row)">查看</Button
        ><Button @click="openStatusAdd(row)">添加</Button>
      </template>
      <template slot-scope="{ row, index }" slot="action">
        <Button size="small" @click="opemUpdate(row, index)">编辑</Button>
        <Button size="small" @click="del(row, 1)">删除</Button>
      </template>
    </Table>
    <div id="mypage">
      <div>
        <Page
          :current="1"
          :total="total"
          :page-size="searchItem.pageSize"
          :page-size-opts="[10, 50, 100]"
          show-total
          show-elevator
          show-sizer
          @on-change="changePage"
          @on-page-size-change="pageSizeChange"
        ></Page>
      </div>
    </div>
    <form-model
      :title="isAdd ? '新增数据' : '编辑数据'"
      width="700"
      ref="formModel"
    >
      <Button slot="btn" type="primary" @click="addUpdate">提交表单</Button>
    </form-model>
    <Modal
      v-model="openForm"
      title="拜访记录"
      footer-hide
      width="1200"
      @on-cancel="getList"
    >
      <baifangjilu ref="baifangjilu"></baifangjilu>
    </Modal>
  </div>
</template>
<script>
import baifangjilu from "./baifangjilu.vue";
export default {
  components: { baifangjilu },
  data() {
    return {
      isAdd: false,
      columns: [
        {
          type: "index",
          width: 70,
          align: "center",
        },
        {
          title: "跟进状态",
          key: "status2",
          slot: "status2",
          minWidth: 130,
          maxWidth: 230,
          sort: 3,
        },
        {
          title: "跟进记录",
          slot: "baifang",
          minWidth: 130,
          maxWidth: 230,
          sort: 3,
        },
        {
          title: "业务员",
          key: "saleman",
          minWidth: 130,
          maxWidth: 230,
          sort: 3,
        },
        {
          title: "操作",
          slot: "action",
          width: 180,
          align: "center",
          fixed: "right",
          sort: 20,
        },
      ],
      tableData: [],
      item: {
        groupId: "",
        groupName: "", //不传后台
        customer: "",
        contact: "",
        tel: "",
        saleman: "", //业务员
        salemanId: "", //业务员id
        assignId: "", //	分派用户 不传后台
        assignId: "", //	分派用户账号Id
        remark: "",
      },

      searchItem: {
        keyword: "",
        pageNumber: 1,
        pageSize: 50,
      },
      searchForms: [
        {
          title: "时间范围",
          key: "startTime",
          key1: "endTime",
          required: true,
          val: 0,
          type: "lyyymmdd",
          times: "4,2,0",
        },
      ],
      total: 0,
      openForm: false,
      forms: [
        {
          title: "客户名称",
          key: "customer",
          type: "Input",
          required: true,
        },
        {
          title: "联系人",
          key: "contact",
          required: true,
          type: "Input",
        },
        {
          title: "电话",
          key: "tel",
          type: "Input",
          required: true,
        },
        {
          title: "业务员",
          key4: "salemanId",
          key1: "saleman",
          type: "selectUser",
          required: false,
          keyword:'业务员'
        },
        {
          title: "备注",
          key: "remark",
          type: "Input",
          type1: "textarea",
        },
      ],
    };
  },
  methods: {
    getList() {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-tms-server-smm/orders/list",
        data: this.searchItem,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        this.total = res.data.data.total;
        var data = res.data.data.dataList;
        for (let i = 0; i < data.length; i++) {
          data[i].status2 = this.lydic.getVal("cusStatus", data[i].status);
        }
        this.tableData = data;
      });
    },
    addUpdate(name) {
      var a = this.$refs.formModel.getItem();
      if (!a) {
        return;
      }
      this.item = a;
      if (this.isAdd) {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-smm/orders/add",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      } else {
        this.axios({
          method: "post",
          url: this.axios.ipPort + "/cloud-tms-server-smm/orders/update",
          data: this.item,
        }).then((res) => {
          if (res) {
            this.$refs.formModel.close();
            this.getList();
          }
        });
      }
    },
    //删除公司
    del(row, n) {
      this.$Modal.confirm({
        title: "删除后数据无法恢复，确定要删除？",
        //content: "退出系统后需要重新登录",
        onOk: () => {
          this.axios({
            method: "post",
            url: this.axios.ipPort + "/cloud-tms-server-smm/orders/del",
            data: { idList: [row.id] },
          }).then((res) => {
            if (res) {
              this.getList();
            }
          });
        },
      });
    },
    //点击编辑按钮
    opemUpdate(row) {
      this.isAdd = false;
      this.item = JSON.parse(JSON.stringify(row));
      this.$refs.formModel.reach(this.forms, this.item);
    },
    openAdd() {
      this.isAdd = true;
      this.$refs.formModel.reach(this.forms, this.item);
    },
    changePage(x) {
      this.searchItem.pageNumber = x;
      this.getList();
    },
    //每页总条数切换
    pageSizeChange(x) {
      this.searchItem.pageSize = x;
      this.getList();
    },
    search() {
      this.getList();
    },
    getSearchItem() {
      this.searchItem = this.$refs.selectTool.getItem();
      this.getList();
    },
    openStatus(v, x) {
      this.openForm = true;
      this.$refs.baifangjilu.reach(v);
    },
    openStatusAdd(v, x) {
      this.$refs.baifangjilu.reachAdd(v);
    },
    abcabc(x, y) {
      setTimeout(() => {
        console.log(this.$refs.baifang);
      }, 200);
    },
  },
  mounted() {
    var config = {
      min: 100,
      max: 240,
    };
    this.columns = this.utils.cols(this.forms, this.columns);
    this.$refs.selectTool.reach(this.searchForms, this.searchItem);
    setTimeout(() => {
      this.getSearchItem();
    }, 300);
  },
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/wuliu/xiaoshou/xiaoshoudingdan.vue